    // Wait for the DOM content to be fully loaded

document.addEventListener('DOMContentLoaded', function() {



    // Define a function to be called repeatedly until the element is found
    function waitForElement(selector, callback) {
        var interval = setInterval(function() {
            // Find the element using the provided selector
            var element = document.querySelector('.cpb-current-view');
            
            // If the element is found, call the callback function and clear the interval
            if (element) {
                clearInterval(interval);
                callback(element);
            }
        }, 100); // Check every 100 milliseconds
    }
    
    // Example usage:
    waitForElement('.cpb-render-wrapper', function(element) {
        // Once the element with class 'cpb-render-wrapper' is found, do something with it
        console.log("Element found:", element);
        // Add your code here to manipulate the element or perform any other action
      if (element) {
            // Create an image element
        
            var imageUrl = "//bekind.pt/cdn/shop/t/12/assets/live-preview.png?v=55286862219511138441787319435";
            var imageElement = new Image();
            
            // Set attributes for the image element (replace 'path/to/your/image.jpg' with your image path)
              imageElement.src = imageUrl;
                imageElement.alt = 'Live Preview'; // Optional: Set alt attribute for accessibility
                imageElement.classList.add('livepreview'); // Add the class "livepreview" to the image
            
            // Append the image element to the wrapper element
            element.appendChild(imageElement);
        }
    });


});
